export interface FeatureFlag {
  value: string;
  config: string | null | undefined;
}

export enum FeatureFlagName {
  AUTO_ASSIGN_DISABLED = "AUTO_ASSIGN_DISABLED",
  CRM_HOUSEHOLD_ONLY = "CRM_HOUSEHOLD_ONLY",
  EXCEL_FILL_ENABLED = "EXCEL_FILL_ENABLED",
  PARAGON_SALESFORCE = "PARAGON_SALESFORCE",
  PDF_FILL_ENABLED = "PDF_FILL_ENABLED",
  DELIVERABLES_ENABLED = "DELIVERABLES_ENABLED",
}

export enum PublicFeatureFlags {
  SOCIAL_LOGIN = "SOCIAL_LOGIN",
}
